import dynamic from "next/dynamic";
import { renderLineBreaks } from "../../../utils";
import { Section } from "../index";

import {
  PathologiesWrapperMobile,
  MobileHeader,
  Title,
  Description,
  ButtonWrapper,
  PathologiesItemsWrapper,
  ArrowsWrapper,
  ArrowLeft,
  ArrowRight,
} from "./styles";
import { useEffect, useRef, useState } from "react";
import useScrollButtons from "../../../lib/hooks/use-scroll";

const PathologiesItem = dynamic(() =>
  import("../../elements/pathologies-item/pathologies-item")
);
const Link = dynamic(() => import("../../elements/link/link"));

export const Pathologies = ({
  sectionTitle,
  sectionSubtitle,
  hideLineSeparation,
  title,
  description,
  button,
  pathologies,
  displaySetting
}) => {

  const { scrollContainerRef, isLeftButtonOn, isRightButtonOn, scrollLeft, scrollRight } = useScrollButtons(140);


  return (
    <Section
      title={sectionTitle}
      subtitle={sectionSubtitle}
      hideLine={hideLineSeparation}
      displayMode={displaySetting?.displayMode}
      smallMargin={displaySetting?.smallBottomMargin}
    >
      <PathologiesWrapperMobile>
        <MobileHeader>
          {title && <Title>{title}</Title>}
          {description && (
            <Description>{renderLineBreaks(description)}</Description>
          )}
        </MobileHeader>
        <PathologiesItemsWrapper ref={scrollContainerRef}>
          {pathologies.map((pathology) => (
            <PathologiesItem key={pathology.id} {...pathology} />
          ))}
        </PathologiesItemsWrapper>
        {button && (
          <ButtonWrapper>
            <Link type="buttonPrimary" {...button} />
          </ButtonWrapper>
        )}
        {pathologies.length > 5 &&
          <ArrowsWrapper>
            <ArrowLeft size={32} onClick={scrollLeft} disabled={!isLeftButtonOn} />
            <ArrowRight size={32} onClick={scrollRight} disabled={!isRightButtonOn} />
          </ArrowsWrapper>
        }
      </PathologiesWrapperMobile>
    </Section >
  );
};

export default Pathologies;
